import {
  Modal,
  Form
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
} from "react";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import ViewPayment from "./ViewPayment";
import { CustomTable, CustomTableExtend, FileDetail } from "@/hocComponents";

const MainTable = forwardRef((props, ref) => {
  const initTableHead = {
    amount: undefined,
    customerAccount: undefined,
    invoice: undefined,
    remark: undefined,
    batch: undefined,
    udate: undefined,
    printBy: undefined,
  }
  const [tableHead, setTableHead] = useState(initTableHead);

  const [checkModalFlag, setCheckModalFlag] = useState(false);
  const [checkFileList, setCheckFileList] = useState([]);

  const [form] = Form.useForm();
  const [viewPaymentOpen, setViewPaymentOpen] = useState(false);
  const [viewPaymentRecord, setViewPaymentRecord] = useState(null);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn})
  }

  const initColumns = [
    // {
    //   dataIndex: '#'
    // },
    // {
    //   title: "Action",
    //   key: "action",
    //   dataIndex: "",
    //   hidden: false,
    //   align: "center",
    //   width: 80,
    //   render: (text, record, index) => (
    //     (commonFn.btnAuthorityFlag("Edit") || commonFn.btnAuthorityFlag("Delete")) && (<Dropdown
    //       menu={{
    //         items: [
    //           commonFn.btnAuthorityFlag("Edit") && {
    //             key: "edit",
    //             icon: <EditOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
    //             label: <div>Edit</div>,
    //           },
    //           commonFn.btnAuthorityFlag("Delete") && {
    //             key: "delete",
    //             icon: <HistoryOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
    //             label: <div>Delete</div>,
    //           },
    //         ],
    //         onClick: (e) => handleMenuClick(e, record),
    //       }} 
    //       trigger={["click"]}
    //     >
    //       <MenuOutlined className="col-blue" />
    //     </Dropdown>
    //     )) || null
    // },
    {
      title: "Trust",
      dataIndex: "trust",
      titleType: "",
      isSorter: true,
      sortterMultiple: 3,
    },
    {
      title: 'Prop',
      dataIndex: "prop",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'prop')
    },
    {
      title: 'Address',
      dataIndex: "address",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'address')
    },
    {
      title: "City",
      dataIndex: "city",
      titleType: "",
      width: 100,
      sortterMultiple: 3,
    },
    {
      title: "Vendor Name",
      dataIndex: "vendorName",
      titleType: "Input",
      width: 200,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "vendorName"),
    },
    {
      title: 'Gl-Title',
      dataIndex: "glAcct",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'glAcct'),
    },
    {
      title: 'Check Date',
      dataIndex: "checkDate",
      titleType: 'DatePicker',
      isSorter: false,
      format: 'MM/DD/YYYY',
      onChange: (e) => tableFilterFn(e, 'checkDate', 'DatePickerFormat'),
    },
    {
      title: "Check #",
      dataIndex: "checkNumber",
      titleType: "Input",
      width: 110,
      isSorter: true,
      sortterMultiple: 2,
      onChange: (e) => tableFilterFn(e, 'checkNumber'),
      render: (text, record) => {
        if (text == null || text === "") return "";
        if(!record?.checkCopyFileStatus) return text
        return (
          <span
            onClick={() => (setCheckFileList([record?.checkCopyFile]), setCheckModalFlag(true))}
            style={{
              color: "#1890ff",
              cursor: "pointer",
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: "Amount",
      dataIndex: "amount",
      titleType: "Input",
      isSorter: true,
      isAmountFlag: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "amount"),
      render: (text, record) => {
        if (text == null || text === "") return "-";
        const colorMatch = {
          0: '#000',
          1: '#dd4b39',
          2: 'green',
          3: '#f39c12',
        }
        return (
          <span
            onClick={() => {
              if(!record?.paymentColorStatus) return
              setViewPaymentRecord({
                ...record,
                paymentId: record.vendorPaymentId,
                type: 'approval'
              })
              setViewPaymentOpen(true)
            }}
            style={{
              color: colorMatch[record?.paymentColorStatus || 0],
              cursor: record?.paymentColorStatus ? "pointer" : "",
            }}
          >
            {commonFn.amountToDollarFn(text)}
              <br />
            {record?.paymentStatusRemark}
          </span>
        );
      },
    },
    {
      title: 'Bank #',
      dataIndex: "bankAcctNumber",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'bankAcctNumber'),
    },
    {
      title: 'Customer #',
      dataIndex: "customerNumber",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'customerNumber'),
    },
    {
      title: 'Invoice #',
      dataIndex: "invoiceNumber",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'invoiceNumber'),
    },
    {
      title: 'Check Memo',
      dataIndex: "checkMemo",
      titleType: 'Input',
      width: 180,
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'checkMemo'),
    },
    {
      title: "Batch",
      dataIndex: "batchNumber",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'batchNumber'),
    },
    {
      title: 'Updated Date',
      dataIndex: "updatedDate",
      titleType: '',
      isSorter: false,
      onChange: (e) => tableFilterFn(e, 'updatedDate', 'DatePickerFormat'),
    },
    {
      title: 'Print By',
      dataIndex: "printBy",
      titleType: '',
      isSorter: false,
    },
  ]

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
    };
    const response = await http.post(api.approvalHistoryShow, params);
    if(!response) return
    if(response && response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const initColunmsFn = () => {
    setPagination({
      current: 1,
      pageSize: 25,
      total: 0,
    })
    setTableList([])
    setTableHead(initTableHead);
    setColumns(initColumns);
  }

  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 25)
  }, [refreshKey])

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('Download') && 'download']}
      >
      </CustomTableExtend>

      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={false}
        rowKey="id"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
      />

      <Modal
        title="VIEW CHECK #"
        width="50%"
        maskClosable={false}
        open={checkModalFlag}
        onCancel={() => (setCheckModalFlag(false), setCheckFileList([]))}
        footer={false}
      >
        <FileDetail
          urlKey="url"
          nameKey="fileName"
          fileList={checkFileList || []}
          customConfig={{
            pdfHeight: "74vh",
            pdfUrlArg: '#zoom=56'
          }}
        />
      </Modal>

      <ViewPayment
        addopen={viewPaymentOpen}
        form={form}
        handleModalCancelFn={() => setViewPaymentOpen(false)}
        record={viewPaymentRecord}
      />
      
    </div>
  );
});
export default MainTable;